const LearnNewLayout = () => import('@/views/learn-new/index.vue')

export default [
  {
    path: '/learning/:elementType',
    name: 'LearnNewLayout',
    component: LearnNewLayout,
  },
]
